import styled from 'styled-components/macro'
import { CheckboxSvg } from './CheckboxSvg'

const rect = `
  rect {
    fill: var(--gray-100);
    stroke-width: 1;
    stroke: var(--border-subtle);
  }
`

export const Wrap = styled.div<{
  disabled: boolean
  margin?: string
  inline?: boolean
}>(({ disabled, margin = '0 0 1.5rem 0', inline = false }) => {
  const styles = `
    margin: ${margin};
    user-select: none;
    width: fit-content;
    display: ${inline ? 'inline-block' : 'block'};
  `
  if (disabled) {
    return `
      ${styles}
      ${rect}
    `
  }
  return styles
})

export const StyledInput = styled.input`
  opacity: 0;
  position: absolute;
  width: 100%;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
`

export const Label = styled.label`
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  color: var(--text-strong);
  font-weight: ${({ bold }: { bold: boolean; margin?: string }) =>
    bold ? 'var(--font-weight-medium)' : 'var(--font-weight-regular)'};
  font-size: var(--mantine-font-size-sm);
  line-height: var(--mantine-line-height-cozy);
  margin: ${({ margin }: { bold: boolean; margin?: string }) =>
    margin && margin === '0' ? '0' : '0 0 0.25rem 0.1rem'};
`

export const SubLabel = styled.label`
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  color: var(--text-strong);
  font-weight: ${({ bold }: { bold: boolean; margin?: string }) =>
    bold ? 'var(--font-weight-medium)' : 'var(--font-weight-regular)'};
  font-size: var(--mantine-font-size-2xs);
  line-height: var(--mantine-line-height-relaxed);
  margin: ${({ margin }: { bold: boolean; margin?: string }) =>
    margin && margin === '0' ? '0' : '0 0 0.25rem 1.6rem'};
`

export const StyledCheckboxSvg = styled(CheckboxSvg)<{
  checked: boolean
  disabled?: boolean
}>`
  margin-right: 0.5rem;

  path {
    fill: ${({ checked, disabled }) =>
      checked && disabled && 'var(--gray-400)'}
`
